import { render, staticRenderFns } from "./Topper.vue?vue&type=template&id=43a1b52b"
import script from "./Topper.vue?vue&type=script&lang=js"
export * from "./Topper.vue?vue&type=script&lang=js"
import style0 from "./Topper.vue?vue&type=style&index=0&id=43a1b52b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports